export default function consoleMessage(message) {
  console.info("%c" + message,
    `
      color: #c099f8;
      background: #121b26;
      padding: 12px 20px;
      border: 1px solid #c099f8;
      border-radius: 4px;
      font-weight: 500;
    `);
}
